import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {FooterBar} from 'shells/modal/footer-bar';

import styles from './default-footer.module.css';

type Props = {
    onCancel: () => void;
    isSaving: boolean;
    errorSaving?: boolean;
    buttonText?: string;
    savingText?: string;
};

export function DefaultFooter(props: Props) {
    return (
        <div id='create-entity-footer' className={styles['default-footer']}>
            <FooterBar
                left={
                    <ButtonMover size='big' direction='left'>
                        <Button variant='text' size='big' onClick={props.onCancel}>
                            Cancel
                        </Button>
                    </ButtonMover>
                }
                right={
                    <SaveButton
                        // @ts-expect-error
                        id='save-entity'
                        buttonText={props.buttonText}
                        savingText={props.savingText}
                        isSaving={props.isSaving}
                        errorSaving={props.errorSaving}
                    />
                }
            />
        </div>
    );
}
